module.exports = __webpack_public_path__ + "img/but4.944189bf.png";